export default __webpack_public_path__ + "static/media/eag.ffbdd878.svg";